import React from 'react';

import { PreConf } from 'presentation/pages';

export const MakePreConfFactory: React.FC = (): JSX.Element => {
  return <PreConf />;
};
